import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// Standard class combiner (tailwind-standardization D5): clsx for conditional
// composition, tailwind-merge so a caller-supplied utility beats the
// component's default for the same CSS property instead of tying in the
// cascade.
export const cn = (...inputs) => twMerge(clsx(inputs));
